import { render, staticRenderFns } from "./WorkflowsWizard.vue?vue&type=template&id=628ad62a"
import script from "./WorkflowsWizard.vue?vue&type=script&lang=js"
export * from "./WorkflowsWizard.vue?vue&type=script&lang=js"
import style0 from "./WorkflowsWizard.vue?vue&type=style&index=0&id=628ad62a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports